import { useMemo } from "react"
import { BarChart } from "@mui/x-charts"

import type { BarPlotView } from "types/dashboard.types"

import useMuiBarConfig from "widgets/plots/configuration/useMuiBarConfig"

interface MuiBarChartProps {
  view: BarPlotView
}

const MuiBarChart = ({ view }: MuiBarChartProps) => {
  const config = useMuiBarConfig({ view })
  const { series, dataset, xAxis, yAxis, margin, grid, legend, gridStyle } = config

  const sx = useMemo(
    () => ({
      "&& .MuiChartsAxis-line, && .MuiChartsAxis-tick": {
        stroke: config.axisColor,
      },
      "& .MuiChartsGrid-line": gridStyle,
    }),
    [config.axisColor, gridStyle],
  )

  return (
    <>
      {series.length > 0 && dataset.length > 0 && (
        <BarChart
          skipAnimation
          hideLegend={legend?.hidden}
          dataset={dataset}
          margin={margin}
          xAxis={xAxis}
          yAxis={yAxis}
          series={series}
          grid={grid}
          sx={sx}
        />
      )}
    </>
  )
}

export default MuiBarChart
